<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Payslip</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">HRM</li>
          <li class="breadcrumb-item active" aria-current="page">Payslip</li>
        </ol>
      </nav>
    </div>
    <div class="head-icons ms-2"></div>
  </div>
  <!-- /Breadcrumb -->
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <div class="d-flex my-xl-auto align-items-center flex-wrap row-gap-3">
        <div class="dropdown me-3">
          <!-- <input type="month" [formControl]="selectedMonth" class="form-select" /> -->
          <input
            type="text"
            #monthInput
            placeholder="YYYY-MM"
            [formControl]="selectedMonth"
            class="form-control"
          />
        </div>

        <div
          *ngIf="
            currentLoggedInUserRole === 'Business Owner' || currentLoggedInUserRole === 'Admin'
          "
          class="dropdown me-3"
        >
          <select class="form-select" [formControl]="selectedBusiness">
            <option value="" selected disabled>Select Business Entity</option>
            <option *ngFor="let item of businessesList" [value]="item.id">
              {{ item.businessName | capitalize }}
            </option>
          </select>
        </div>
        <!-- Search Box -->
        <div
          *ngIf="
            currentLoggedInUserRole === 'Business Owner' || currentLoggedInUserRole === 'Admin'
          "
          class="me-3"
        >
          <input
            appTrimInput
            type="text"
            class="form-control"
            placeholder="Search employees..."
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange()"
          />
        </div>
        <!--<div class="dropdown me-3">
          <select class="form-select" [formControl]="selectedPayrollIndex">
            <option value="" selected disabled>Select Employee</option>
            <option *ngFor="let item of payrolls; let i = index" [value]="i">
              {{ item.employee.firstName | capitalize }} {{ item.employee.lastName | capitalize }}
              {{ item.employee.empId }}
            </option>
          </select>
        </div>-->
      </div>
    </div>
  </div>
  <ng-container *ngIf="filteredpayrolls$ | async as filteredPayrolls; else noPayrolls">
    <div class="card" *ngIf="filteredPayrolls.length > 0; else noPayrolls">
      <div class="card-header">
        <h5 class="card-title">Payslip Preview</h5>
      </div>
      <div class="card-body">
        <table class="table datatable">
          <thead class="thead-light">
            <tr>
              <th scope="col">Employee</th>
              <th scope="col">Payslip</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let payroll of filteredPayrolls">
              <!-- <th scope="col"> -->
              <td>
                <div class="d-flex align-items-center">
                  <a
                    [routerLink]="[eps.hrm.employeePath, payroll.employee.id]"
                    class="avatar avatar-md"
                  >
                    <!-- <img
                        [src]="employee.picture ? businessImages[employee.picture] : defaultImg"
                        class="img-fluid rounded-circle"
                        alt="img"
                      /> -->
                    <ng-container *ngIf="payroll.employee.picture; else initials">
                      <img
                        [src]="imageBaseUrl + payroll.employee.picture"
                        class="img-fluid rounded-circle"
                        alt="img"
                        style="width: 100%; height: 100%; object-fit: cover"
                      />
                    </ng-container>

                    <ng-template #initials>
                      <span
                        class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                        style="width: 30px; height: 30px"
                        >{{
                          getInitials(payroll.employee.firstName, payroll.employee.lastName)
                        }}</span
                      >
                    </ng-template>
                  </a>
                  <div class="ms-2">
                    <p class="text-dark mb-0">
                      <a [routerLink]="[eps.hrm.employeePath, payroll.employee.id]"
                        >{{ payroll.employee.firstName | capitalize }}
                        {{ payroll.employee.lastName | capitalize }}</a
                      >
                      <span class="fs-12"> ({{ payroll.employee.empId }})</span>
                    </p>
                    <span class="fs-12">{{
                      payroll.employee.designation?.designationName | capitalize
                    }}</span>
                  </div>
                </div>
                <!-- </th> -->
              </td>
              <!-- <th scope="col"> -->
              <td>
                <button (click)="openModal(PayslipComponent, payroll)" class="btn bg-transparent">
                  <i class="ti ti-eye"></i>
                </button>
              </td>
              <!-- </th> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
  <ng-template #noPayrolls>
    <div class="alert alert-warning d-flex align-items-center justify-content-center">
      <i class="ti ti-exclamation-circle"></i>
      <span>&nbsp; No payslips available.</span>
    </div>
  </ng-template>
</div>
